import React from "react";
import { motion } from "framer-motion";
import estudioImg from "../assets/professional/estudio.jpg";


export default function AboutStudio() {
  return (
    <section id="acerca" className="py-20 px-6 md:px-20 bg-background">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

        {/* --- IMAGEN --- */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <img
            src= {estudioImg}
            alt="Estudio Jurídico"
            className="w-full h-[350px] md:h-[480px] object-cover rounded-xl shadow-lg"
          />
        </motion.div>

        {/* --- TEXTO --- */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center md:text-left"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-6">
            Acerca del Estudio
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto md:mx-0 mt-6">
              Brindamos soluciones en derecho comercial, societario, concursal, laboral y penal, con foco en la estrategia y
              la prevención de conflictos.
          </p> 
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto md:mx-0 mt-6">
              Desde 1998 acompañamos a compañías en la toma de decisiones clave,
              la reestructuración de pasivos y la gestión integral de sus riesgos legales.
             
          </p>

          <div className="mt-8 flex justify-center md:justify-start">
            <a href="#profesionales" className="btn-primary">
              Conocer al equipo
            </a>
          </div>
        </motion.div>

      </div>
    </section>
  );
}
